import React, { useState, useEffect } from "react";
import { Table } from 'react-bootstrap'
import moment from "moment";
import { numberFormat } from "../../helper";
import { S3_URL } from "../../const";

export default function BillOfferPriceV4({
  cartDatas,
  activeCart,
  offerPrice,
  codeBill,
  customername,
  phonenumber,
  village,
  district,
  province,
  customerLastName }) {

  const index = cartDatas.findIndex(item => item?.label === activeCart)
  const shop = JSON.parse(localStorage.getItem('SHOP_DATA'))
  const currentDateTime = new Date().toLocaleString();

  return (
    <div>
      <div style={{ border: "1px solid black", padding: "10px" }}>
        <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px" }}>{shop?.name}</div>
        <div style={{ textAlign: "center", display: "flex", alignItems: "center" }}>
          <div><img src={S3_URL + shop?.image} width="50px" /></div>&emsp;
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
            <div> {shop?.address?.village + ", " + shop?.address?.district + ", " + shop?.address?.province}</div>
            <div> ໂທ : {shop?.phone} Email:</div>
          </div>
        </div>
        <div>

        </div>
      </div>
      <div style={{ fontWeight: "bold", textAlign: 'center' }}>ໃບສະເໜີລາຄາ / Quotation</div>
      <div>ຂໍຮຽນ :</div>
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <div style={{ border: "0.5px solid black", display: "flex", flexDirection: "column", width: "70%", padding: "5px" }}>
          <span>ລູກຄ້າ : {customername} {customerLastName}</span>
          <span>ທີ່ຢູ່ :{village}, {district}, {province} </span>
          <span>Tel :&emsp;{phonenumber}</span>
        </div>
        &emsp;
        <div style={{ border: "0.5px solid black", display: "flex", flexDirection: "column", width: "30%", padding: "5px" }}>
          <span>Doc No. : {codeBill?.code}</span>
          <span>ວັນທີ : {currentDateTime}</span>
          <span>Credit :</span>
          <span>ໝົດກຳນົດ :</span>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <Table bordered size="sm" style={{ border: "1px solid black" }}>
          <thead>
            <tr>
              <th>ລ/ດ555</th>
              <th>ຊື່ສິນຄ້າ</th>
              <th>ຈຳນວນ</th>
              <th>ຫົວໜ່ວຍ</th>
              <th>ລາຄາໝວ່ຍ</th>
              <th>ລາຄາລວມ</th>
              <th>ໝາຍເຫດ</th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "14px" }}>
            {
              cartDatas[index]?.data?.orders?.map((order, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{order?.productName}</td>
                  <td>{order?.amount}</td>
                  <td>{order?.unit}</td>
                  <td>{order?.price ? numberFormat(order?.price) : "-"}</td>
                  <td>{numberFormat(order?.price * order?.amount)}</td>
                  <td>{order?.note ?? ""}</td>
                </tr>
              ))
            }
          </tbody>
        </Table>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "40%", border: '1px solid black', height: "auto", padding: '5px' }}>
            <div style={{ display: "flex", justifyContent: 'space-between' }}>
              <span>ຍອດລວມ ບາດ:</span>
              <span>{numberFormat(cartDatas[index]?.data?.orderGroup?.sumPriceBaht ?? 0)} B</span>
            </div>
            <div style={{ display: "flex", justifyContent: 'space-between' }}>
              <span>ຍອດລວມ ກີບ:</span>
              <span>{numberFormat(cartDatas[index]?.data?.orderGroup?.totalPrice ?? 0)} ₭</span>
            </div>
            <div style={{ display: "flex", justifyContent: 'space-between' }}>
              <span>ຍອດລວມ ໂດລາ:</span>
              <span>{numberFormat(cartDatas[index]?.data?.orderGroup?.sumPriceUsd ?? 0)} $</span>
            </div>
             
            <div style={{ display: "flex", justifyContent: 'space-between' }}>
              <span>ລາຄາລວມທັງໝົດ:</span>
              <span>{numberFormat(cartDatas[index]?.data?.orderGroup?.sumPrice ?? 0)} {cartDatas[index]?.orderGroup?.currency ?? '₭'}</span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", marginTop: "20px" }}>
        <div style={{
          width: "150px",
          border: "1px solid black",
          borderRadius: "8px",
          height: "70px",
          fontSize: "12px",
          display: "flex",
          justifyContent: 'center',
        }}>
          <div style={{ textAlign: "center", borderTop: "1px solid black" }} >
            (...)<br /> ຜູ້ສະເໜີລາຄາ</div>
        </div>&ensp;
        <div style={{
          width: "150px",
          border: "1px solid black",
          borderRadius: "8px",
          height: "70px",
          fontSize: "12px",
          display: "flex",
          justifyContent: 'center',
        }}>
          <div style={{ textAlign: "center", borderTop: "1px solid black" }} >
            (...)<br />
            Sale Manager</div>
        </div>&ensp;
        <div style={{
          width: "150px",
          border: "1px solid black",
          borderRadius: "8px",
          height: "70px",
          fontSize: "12px",
          display: "flex",
          justifyContent: 'center',
        }}>
          <div style={{ textAlign: "center", borderTop: "1px solid black" }} >
            ລູກຄ້າເຊັນຮັບເຄື່ອງ<br />
            ລົງວັນທີເເລະປະທັບຕາ (ຖ້າມີ)</div>
        </div>
      </div>


    </div>
  )
}
